import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import GenericInput from './GenericInput';
import MultipleFilesInput from 'app/Components/Shared/MultipleFileInput/MultipleFilesInput';
import BtnNextStep from '../../BtnNextStep';
import { GenericInputTypeDef , fileExtensions , ParamsNeedingAdditionalValidation ,errorMessages } from '../../Constant/Constant';
import { validateInput , TextInputEnum } from '../../../../../utilities/validation/InputValidation';
import { setInputsList  , setInputsListBulk , setFiles , setDeviceRepairSubscribersList , initialState , setDeviceRepairFile , validateSelectedAccount, SubscriberErrorEnum} from '../../BusinessWorkOrderSystemSlice';
import { BusinessWorkOrderSystemStep , DeviceRepairCsvHeaders , DeviceRepairCsvFields} from '../../Constant/Constant';
import { showAppLoader , hideAppLoader } from 'app/Components/Shared/Loader/LoaderSlice';
import DatePicker from 'app/Components/Shared/DatePicker/DatePicker';
import DynamicElementList from 'app/Components/Shared/DynamicElementList/DynamicElementList';
import Helper from '../../../../../utilities/helper';
import { createCsv } from '../../../../../utilities/fileHelper';
import DeviceRepair from './DeviceRepair/DeviceRepair';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';


const WorkOrderForm = ({businessWorkOrderSystem, setInputsList, setInputsListBulk, workOrderParams, setFiles , setDeviceRepairSubscribersList ,showAppLoader , hideAppLoader , setDeviceRepairFile , validateSelectedAccount , orgId, contentData}) => {

  const [error, setError] = useState(false);
  const [paramsToDisplayOnInit, setParamsToDisplayOnInit] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [lastSubscriberValidated, setLastSubscriberValidated] = useState({
    subscriber: '',
    numberValidationComplete: false,
  });

  const [fileError, setFileError] = useState(false);

  useEffect(() => {
    if(error){
       checkIfCanContinue();
    }
  }, [workOrderParams , businessWorkOrderSystem.deviceRepairSubscribersList]);


   const checkIfCanContinue = async () => {
    var hasErrors = Object.values(workOrderParams || {}).some((param) => param.error);
    if(businessWorkOrderSystem.selectedWorkOrderType.isDeviceRepair){
      var res = await validateLastSubscriber();
      hasErrors = hasErrors || !res;
    }
     setError(hasErrors);
   }



  const validateAllInputs = async () => {
      var bulkUpdates = {};
      var validationResults = Object.values(workOrderParams || {}).map(param => {
      const inputType = GenericInputTypeDef[param.paramTypeDefinition.paramType]?.inputValidationType ?? TextInputEnum.None;
      var error = validateInput(param.value, inputType, param.display && param.isRequired);
      if(isNullOrEmpty(error) && ParamsNeedingAdditionalValidation.includes(param.paramTypeDefinition.paramType) && !param.validated && param.display && param.isRequired){
        error = errorMessages.anotherValidation;
      }
      bulkUpdates[param.paramCode] = {
        value: param.value,
        error: error
      };
      return { paramCode: param.paramCode , error };
    });

     var hasErrors = validationResults.some(result => result.error) || fileError;
     setInputsListBulk(bulkUpdates);
     setIsSubmit(true);


    if(businessWorkOrderSystem.selectedWorkOrderType.isDeviceRepair && !hasErrors) {
      var res = await validateLastSubscriber();
      if(!res){
          hasErrors = true;
      }else{
        var file = await createCsv(
          businessWorkOrderSystem.deviceRepairSubscribersList,
          DeviceRepairCsvHeaders,
          DeviceRepairCsvFields,
          Helper.genarateUuid4()+'_deviceRepair',false);
          file = {isDeviceRepair: true, ...file};
          setDeviceRepairFile(file);
        }
      }

      if(!hasErrors ){
        return BusinessWorkOrderSystemStep.WorkOrderConfirmation;
      }
      setError(hasErrors);
      return false;
  }


  const validateLastSubscriber = async () => {
    var currentSubscriber = businessWorkOrderSystem.deviceRepairSubscribersList[businessWorkOrderSystem.deviceRepairSubscribersList.length - 1];
    var canContinue = true;
    if( currentSubscriber.deviceSerialNumber == ''  || currentSubscriber.causeList.length == 0  || (currentSubscriber.securityCodeExist && currentSubscriber.securityCode == '')){
      canContinue = false;
    }

   var canValidateNumber = !(currentSubscriber.errors?.subscriber || currentSubscriber.subscriber == "");
   if(canValidateNumber){
    if(!(lastSubscriberValidated.subscriber == currentSubscriber.subscriber && lastSubscriberValidated.numberValidationComplete )){
     showAppLoader();
     var res = await validateSelectedAccount({subscriber: currentSubscriber.subscriber, orgId: orgId });
     if(res.payload.isAllowed){
      setLastSubscriberValidated({subscriber: currentSubscriber.subscriber, numberValidationComplete: true});
     }else{
      canContinue = false;
     }
     hideAppLoader();
    }
  }else{
    canContinue = false;
  }
  var lastCause = currentSubscriber.causeList[currentSubscriber.causeList.length - 1];
    if(lastCause.selectedCauseType == '' || lastCause.selectedCauseSubType == ''){
      canContinue = false;
    }
    if(Object.values(currentSubscriber.errors|| {})?.some(error => error)){
      canContinue = false;
    }
    return canContinue;
  }


  const renderInputs = (isUnconditional = false) =>
      Object.values(workOrderParams)
        ?.filter(param => isUnconditional ? param.unconditionalParam : param.display && !param.unconditionalParam)
        ?.map(input => <GenericInput key={input.paramCode} input={input} isSubmit={isSubmit}  contentData={contentData} showSubscriberFullName={true}/>);

    return (
      <div className='business-work-order-system-form'>
        <div className='l-title'>{businessWorkOrderSystem.selectedWorkOrderType?.description}</div>
        <div className='m-title center'>הזינו את פרטי המנוי</div>


        {renderInputs()}
         {businessWorkOrderSystem.selectedWorkOrderType.isDeviceRepair &&
          <DynamicElementList
            elementName="מנוי"
            elementNameWithIndex={true}
            Component={DeviceRepair}
            componentProps={{isSubmit}}
            addButtonText="הוסף מנוי"
            validationBeforeAdd ={() => {
                return validateLastSubscriber();
              }}
            removeButtonText="הסר מנוי"
            setElements={(elements) => {
              setDeviceRepairSubscribersList(elements);
            }}
            isRequired={true}
            elements={businessWorkOrderSystem.deviceRepairSubscribersList}
            initialData={initialState.deviceRepairSubscribersList[0]}
            limit={contentData?.numOfSubscriberDeviceRepair.value}
          />
         }
         {!businessWorkOrderSystem.selectedWorkOrderType.isDeviceRepair &&
         <div className='unconditional-param-container'>
            {renderInputs(true)}
            <MultipleFilesInput files={businessWorkOrderSystem.files}
              setFiles={(value) => setFiles(value)}
              placeholder='טעינת קובץ מנויים וצירוף קבצים לפניה'
              maxSizeFileMB={4}
              setFileError={setFileError}
              fileExtensions={fileExtensions}
            />
         </div>
         }
        <BtnNextStep
          onClick={validateAllInputs}
          text='בחרתי, אפשר להמשיך'
          error={error}
          errorText='אנא השלם את כל הפרטים החסרים'
        />
      </div>

  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
  workOrderParams: state.businessWorkOrderSystem.workOrderParams || {},
  orgId: state.portalsBlock.selectedHetPayId,
});
const mapDispatchToProps = {setInputsList, setInputsListBulk, setFiles, setDeviceRepairSubscribersList , setDeviceRepairFile,showAppLoader , hideAppLoader , validateSelectedAccount};

export default connect(mapStateToProps,mapDispatchToProps)(WorkOrderForm);
